export default "/fonts/mydevicon.svg?6f96f7c0aba1043152a1e2b0202ccd1d";